import { useMemo } from 'react';
import { RadixSelect } from '@/components/ui';
import { useMileageEarnPoliciesQuery } from '../hooks/useMileageEarnPoliciesQuery';

export interface EarnPolicySelectProps {
  /** 선택된 정책 id, 미선택 시 null. */
  value: string | null;
  onChange: (policyId: string | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
}

const UNSET = '';

/**
 * PRODUCT scope 적립 정책 단일 선택 드롭다운 (PolicySelect 미러, 상품폼 by-product 연결용).
 * 한 상품은 최대 하나의 PRODUCT 정책에 매핑되므로 단일 select (쿠폰 다중선택과 다름).
 * raw policyId 는 노출하지 않고 name 만 표시한다.
 */
export const EarnPolicySelect = ({
  value,
  onChange,
  placeholder,
  disabled,
  className,
  ariaLabel,
}: EarnPolicySelectProps) => {
  const query = useMileageEarnPoliciesQuery('PRODUCT');

  const options = useMemo(() => {
    const items = (query.data ?? []).filter((p) => !p.deleted);
    return [
      { value: UNSET, label: placeholder ?? '기본 정책 사용' },
      ...items.map((p) => ({ value: p.id, label: p.name })),
    ];
  }, [query.data, placeholder]);

  return (
    <RadixSelect
      value={value ?? UNSET}
      onChange={(v) => onChange(v ? v : null)}
      options={options}
      placeholder={placeholder ?? '기본 정책 사용'}
      disabled={disabled || query.isPending}
      {...(className !== undefined ? { className } : {})}
      {...(ariaLabel !== undefined ? { 'aria-label': ariaLabel } : {})}
    />
  );
};
